import { useMutation } from "react-query";
import servicesUtils from "../../../../utils/servicesUtils";

const useGetNextSteps = (workspaceId, conversationId) => {
  let url = `/llm_orchestrator/workspaces/${workspaceId}/conversations/${conversationId}/next_steps/`;
  return useMutation((params) => servicesUtils.postService(url, params));
};

export default useGetNextSteps;
